module.exports = __webpack_public_path__ + "static/media/LogoERTurismo-en.210eba64.png";